import { render } from "./crud.vue?vue&type=template&id=33667c26"
import script from "./crud.vue?vue&type=script&lang=js"
export * from "./crud.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__